import Toolbar from "@mui/material/Toolbar";
import {alpha} from "@mui/material";
import Box from "@mui/material/Box";
import React from "react";
import ScrollBar from "./ScrollBar";

const CustomToolbar = ({content, children} : {content?: React.ReactNode | undefined, children: React.ReactNode}) => {
    return (
        <Toolbar
            sx={{
                display: "flex",
                flexDirection: 'column',
                pl: {sm: 2, lg: 1},
                pr: {xs: 1, sm: 1, lg: 1},
                mb: 1,
                backgroundColor: (theme) =>
                    alpha(theme.palette.primary.main, theme.palette.action.activatedOpacity),
            }}
        >
            {content}
            <ScrollBar forceVisible="x" autoHide={false} style={{width: "100%"}}>
                <Box
                    sx={{
                        width: "100%",
                        height: "46px",
                        display: "flex",
                        justifyContent:{xs: "flex-start", sm: "flex-end"},
                        alignItems: "center",
                        mb: 1,
                        pt: 1,
                    }}
                >
                    {children}
                </Box>
            </ScrollBar>
        </Toolbar>
    );
};

export default CustomToolbar;

